import { MatDateFormats } from '@angular/material/core';

export const MY_NATIVE_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY', // Parsing typically follows Moment.js or Day.js format if you're using those
  },
  display: {
    dateInput: 'dd-MM-yyyy',           // This controls what is shown in the input box
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd-MM-yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
